/* eslint-disable */
import MD5 from "crypto-js/md5";
import configs from "./../../common/config";
import { extend } from "jquery";

const config = {
  cookiePostFix: undefined,
  secureCookie: true,
  defaults: {
    expires: 365,
    path: "/",
  },
};
const cookieOptions = configs.cookie;

function raw(s) {
  return s;
}

function decoded(s) {
  const pluses = /\+/g;
  try {
    return decodeURIComponent(s.replace(pluses, " "));
  } catch (e) {
    return null;
  }
}

function converted(s) {
  if (s.indexOf('"') === 0) {
    // This is a quoted cookie as according to RFC2068, unescape
    s = s.slice(1, -1).replace(/\\"/g, '"').replace(/\\\\/g, "\\");
  }
  try {
    return config.json ? JSON.parse(s) : s;
  } catch (er) {}
}

// here we will append for TW_* cookies the optional prefix
// this needs to be set in the options when required
function buildCookieKey(key) {
  if (config.cookiePostFix && key.indexOf("TW_") == 0) {
    return key + "_" + config.cookiePostFix;
  } else return key;
}

export default class CookieManager {
  static cookieKeys = {
    REGION: "TW_REGION",
    DOUBLEPAGE_LANDSCAPEDISPLAY: "TW_DOUBLEPAGE_LANDSCAPEDISPLAY",
    LOGIN: "TW_LOGGED_IN",
    UUID: "TW_USER_DATA",
    UUIDV1: "TW_GUID",
    COOKIE: "cookie-agreed-1",
    FONTSIZE: "TW_FONTSIZE",
    PREFERRED_VIEWER: "TW_PREFERRED_VIEWER",
    READER_SESSION: "TW_READER_SESSION",
    REDIRECTIONS: "TW_REDIRECTIONS",
    SSO_STATE: "TW_SSO_STATE",
    DESKTOP_DOUBLEPAGE: "TW_DESKTOP_DOUBLEPAGE",
    VOUCHER: "TW_VOUCHER",
  };

  /*
    These are cookies that should never expire and we
    want to refresh their expiration date everytime user opens
    the reader
  */
  static longExpirationCookieKeys = [
    CookieManager.cookieKeys.FONTSIZE,
    CookieManager.cookieKeys.DOUBLEPAGE_LANDSCAPEDISPLAY,
    CookieManager.cookieKeys.PREFERRED_VIEWER,
    CookieManager.cookieKeys.REGION,
    CookieManager.cookieKeys.LOGIN,
    CookieManager.cookieKeys.UUID,
    CookieManager.cookieKeys.DESKTOP_DOUBLEPAGE,
  ];

  static setPostFix(postFix) {
    config.cookiePostFix = postFix;
  }

  static getCookie(key) {
    // read
    // uset the client as postfix on the cookies
    key = buildCookieKey(key);
    const decode = config.raw ? raw : decoded;
    const cookies = document.cookie.split("; ");
    let result = key ? undefined : {};
    for (let i = 0, l = cookies.length; i < l; i++) {
      const parts = cookies[i].split("=");
      const name = decode(parts.shift());
      const cookie = decode(parts.join("="));

      if (cookie && key && key === name) {
        result = converted(cookie);
        break;
      }

      if (cookie && !key) {
        result[name] = converted(cookie);
      }
    }

    if (result && config.secureCookie) {
      // the converted function will do all the logic to check if the
      // jsonparsing is safe and correct
      const jsonValue = converted(result);
      if (typeof value !== "boolean" && jsonValue.hash) {
        const hash = jsonValue.hash;
        const hashkey = "hash";
        jsonValue[hashkey] = null;
        delete jsonValue[hashkey];

        const stringJson = JSON.stringify(jsonValue);
        const shouldBeHash = MD5(stringJson).toString();

        if (hash === shouldBeHash) {
          result = stringJson;
          //everything oke
        } else {
          //TODO: remove cookie?
          return null;
        }
      } else if (typeof value !== "boolean") {
        //TODO: create cookie with hash
      }
    }

    return result;
  }

  static createCookie(key, value, options = {}) {
    if (
      config.secureCookie &&
      typeof value != "boolean" &&
      typeof value != "string" &&
      value != ""
    ) {
      const jsonValue = JSON.parse(value);
      const hash = MD5(value).toString();
      jsonValue.hash = hash;
      value = JSON.stringify(jsonValue);
    }

    if (value !== undefined) {
      options = extend({}, config.defaults, options);
      if (typeof options.expires === "number") {
        if (options.useExpires) {
          options.expires = new Date(options.expires);
        } else if (options.useTime) {
          let ms = options.expires,
            t = (options.expires = new Date());
          t.setTime(t.getTime() + ms);
        } else {
          let days = options.expires,
            t = (options.expires = new Date());
          t.setDate(t.getDate() + days);
        }
      }
      value = String(value);
      return (document.cookie = [
        encodeURIComponent(buildCookieKey(key)),
        "=",
        config.raw ? value : encodeURIComponent(value),
        options.expires ? `; expires=${options.expires.toUTCString()}` : "", // use expires attribute, max-age is not supported by IE
        options.path ? `; path=${options.path}` : "",
        options.domain ? `; domain=${options.domain}` : "",
        cookieOptions.disableCookieSameSitePolicy &&
        process.env.NODE_ENV == "production"
          ? "; sameSite=none ; secure "
          : "",
      ].join(""));
    }
  }

  static removeCookie(key, options) {
    if (!options) {
      options = {};
    }
    options.expires = -1;
    if (this.getCookie(key)) {
      this.createCookie(key, "", options);
      return true;
    } else {
      return false;
    }
  }

  static refreshCookies() {
    CookieManager.longExpirationCookieKeys.forEach((key) => {
      const cookie = CookieManager.getCookie(key);
      if (cookie) {
        CookieManager.createCookie(key, cookie);
      }
    });
  }

  static getNumberOfRedirects() {
    var cookie = this.getCookie(this.cookieKeys.REDIRECTIONS);
    if (cookie) {
      return Number(cookie);
    }
    return 0;
  }

  static setNumberOfRedirects(number, time) {
    this.createCookie(this.cookieKeys.REDIRECTIONS, number.toString(), {
      expires: time,
      path: "/",
      useTime: true,
    });
  }

  static _getLoginCookie() {
    const cookie = CookieManager.getCookie(CookieManager.cookieKeys.LOGIN);
    try {
      const value = JSON.parse(cookie);
      return value ? value : null;
    } catch (error) {
      return null;
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/utilities/cookiemanager.js